import { render, staticRenderFns } from "./HomeServiceOperationRankingServiceElderNumber.vue?vue&type=template&id=6456f7d8&scoped=true&"
import script from "./HomeServiceOperationRankingServiceElderNumber.vue?vue&type=script&lang=js&"
export * from "./HomeServiceOperationRankingServiceElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456f7d8",
  null
  
)

export default component.exports